import { useQuery } from '@tanstack/react-query';
import { match } from 'ts-pattern';

import { createGetSpeakerIndex, transcriptOptions } from '@/entities/transcript';

import { TranscriptRow } from './transcript-content/transcript-row';
import { TranscriptSkeleton } from './transcript-content/transcript-skeleton';

type Props = {
    transcriptId: string;
};

export function TranscriptContent({ transcriptId }: Props) {
    const { data: transcript, isPending } = useQuery(transcriptOptions(transcriptId));

    const getSpeakerIndex = createGetSpeakerIndex();

    return match({ isPending })
        .with({ isPending: true }, () => <TranscriptSkeleton />)
        .with({ isPending: false }, () => (
            <div className="grid grid-cols-[1.5rem_1fr] gap-x-4 gap-y-6 text-sm">
                {transcript?.content?.map((entry, index) => (
                    <TranscriptRow
                        key={index}
                        text={entry.text}
                        speakerIndex={getSpeakerIndex(entry.speaker)}
                    />
                ))}
            </div>
        ))
        .exhaustive();
}
